<ng-container *ngIf="_option?.reason?.enabled === true">
    <ng-select
        [options]="_reasonOpts"
        [placeholder]="_option?.reason?.label"
        [disabled]="_isDisabled"
        [ngModel]="_reasonValue"
        (ngModelChange)="_onOptionChange($event)"
    ></ng-select>
</ng-container>
